import React, { useState,useEffect,lazy,Suspense } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {ColumDataTableReorganize,ProfilActionButton,FormatedPrice,BtnShowDocSaved,Loading,useLocalStorage,BtnConvertDocPurchaseOrderB2b,BtnConvertDocDeliveryNoteB2b} from '@gull'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import Moment from 'react-moment';
import { Modal } from "react-bootstrap";
import { documentFormatter,cellStyleEtat,cellStyleEtatConversion,rowStyle } from "../../../../app/views/facturation/datatable_facture_tools";
import {Link} from 'react-router-dom'

const ModalSavedFacture = lazy(() => import('../../modal/ModalSavedFacture'));

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            defaultSortDirection={props.defaultSortDirection}
            rowStyle={ props.rowStyle }
            hover
            condensed
            responsive
        />
    );
};

const DossierListDocumentTable = (props) =>{
    const t = useTranslate();
    let { SearchBar } = Search;

    const moduleInvoice = props.authParam.modules.find(value=>value.name=='invoice')

    const [perPage,setPerPage]=useState(50)
    const [cookies, setCookie] = useCookies(['dossier_facture_table_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['dossier_facture_table_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.dossier_facture_table_reorganize && cookies.dossier_facture_table_reorganize){
            setLocalStorage('dossier_facture_table_reorganize',cookies.dossier_facture_table_reorganize);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false)
    const [filter,setFilter]=useState('all'); 
    const [showModalDocument,setShowModalDocument]=useState(false) 
    const [textModal,setTextModal]=useState(false) 

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)
    var maxCarac = 15;
    
    let dataTable = new Array
    props.folderDetail.facture.length!=0 && props.folderDetail.facture.map((value,ind)=>{
        if(filter=='all' || value.type==filter){
            let finalise=((value.type!='quotation' && value.type!='creditNote' && value.type!='billingDeposit') && value.date_validation && !value.cancelled) ? true : false;

            let tos = (Object.keys(value.tos).length!=0) ? true : false
            let pos = (Object.keys(value.pos).length!=0) ? true : false

            //gestion des états
            let etat1='-';
            let etat2='-';

            if(value.cancelled){//si le documment est annulé, on met tout en annulé
                    etat1=t('canceled')
                    etat2=t('canceled')
            }
            else{//sinon status indépendant
                if(value.type=='quotation'){
                    etat1=(value.etat=='expired') ? t('expired') : t('notExpired')
                    etat2=(value.etat_conversion=='notConverted') ? t('notConverted') : t('converted')
                }
                if(value.type=='billingDeposit'){
                    switch (value.etat) {
                        case 'unUsed':
                            etat1=t('unUsed')
                            break;
                        case 'partiallyUsed':
                            etat1=t('partiallyUsed')
                            break;
                        case 'used':
                            etat1=t('used')
                            break;
                        default:
                            break;
                    }
                }
                if(value.type=='purchaseOrderB2b'){
                    switch (value.etat) {
                        case 'collected':
                            etat1=t('collected')
                            break;
                        case 'collectInProgress':
                            etat1=t('collectInProgress')
                            break;
                        case 'notCollected':
                            etat1=t('notCollected')
                            break;
                        default:
                            break;
                    }
                    switch (value.etat_conversion) {
                        case 'converted':
                            etat2=t('converted')
                            break;
                        case 'partiallyConverted':
                            etat2=t('partiallyConverted')
                            break;
                        case 'notConverted':
                            etat2=t('notConverted')
                            break;
                        default:
                            break;
                    }
                }
                if(value.type=='deliveryNote'){
                    switch (value.etat) {
                        case 'delivered':
                            etat1=t('delivered2')
                            break;
                        case 'notDelivered':
                            etat1=t('notDelivered2')
                            break;
                        default:
                            break;
                    }
                    switch (value.etat_conversion) {
                        case 'converted':
                            etat2=t('isFactured')
                            break;
                        case 'notConverted':
                            etat2=t('isNotFactured')
                            break;
                        default:
                            break;
                    }
                }
                if(value.type=='billing' || value.type=='billingBuy'){
                    switch (value.etat) {
                        case 'notAcquitte':
                            etat1=t('notAcquitte')
                            break;
                        case 'partiallyAcquitte':
                            etat1=t('partiallyAcquitte')
                            break;
                        case 'acquitte':
                            etat1=t('acquitte')
                            break;
                        default:
                            break;
                    }
                }
                if(value.type=='creditNote'){
                    switch (value.etat) {
                        case 'unUsed':
                            etat1=t('unUsed')
                            break;
                        case 'partiallyUsed':
                            etat1=t('partiallyUsed')
                            break;
                        case 'used':
                            etat1=t('used')
                            break;
                        default:
                            break;
                    }
                    switch (value.etat_conversion) {
                        case 'converted':
                            etat2=t('converted')
                            break;
                        case 'partiallyConverted':
                            etat2=t('partiallyConverted')
                            break;
                        case 'notConverted':
                            etat2=t('notConverted')
                            break;
                        default:
                            break;
                    }
                }
                if(value.type=='returnNote'){
                    switch (value.etat) {
                        case 'collected':
                            etat1=t('collected')
                            break;
                        case 'collectInProgress':
                            etat1=t('collectInProgress')
                            break;
                        case 'notCollected':
                            etat1=t('notCollected')
                            break;
                        default:
                            break;
                    }
                }
            }
            //end


            let refacturation = (value.type=='purchaseOrderB2b') ? ((Object.keys(value.refacturation).length!=0) ? true : false) : false
            if (Array.isArray(value.refacturation)) refacturation=true

            let facture = (refacturation) ? value.refacturation.find(elem => elem.type=='billing') : false
            let facture_achat = (refacturation) ? value.refacturation.find(elem => elem.type=='billingBuy') : false

            let url_facture = (!facture) ? false : ((facture.bar!=null) ? '/invoice/details/'+facture.id : '/invoice/document/create-add-items/'+facture.id)
            let url_facture_achat = (!facture_achat) ? false : ((facture_achat.bar!=null) ? '/invoice/details/'+facture_achat.id : '/invoice/document/create-add-items/'+facture_achat.id)

            let refacturation_text = (facture || facture_achat) ? 
                ((moduleInvoice!=undefined) ? 
                    <>{(facture)?<Link className='list-group lien-to' to={url_facture}>{facture.bar??t('draft')}</Link>:<span></span>}/{(facture_achat)?<Link className='list-group lien-to' to={url_facture_achat}>{facture_achat.bar??t('draft')}</Link>:<span></span>}</> 
                : 
                    <>{(facture)?facture.bar??t('draft'):<span></span>}/{(facture_achat)?facture_achat.bar??t('draft'):<span></span>}</>) 
            : 
                t('no')

            let client_str=(value.client_infos.firstname) ? value.client_infos.name+' '+value.client_infos.firstname : value.client_infos.name

            let obj = {
                type: t(value.type),
                bar: value.bar,
                createdAt: <Moment format="DD/MM/YYYY">{value.date_finalisation}</Moment>,
                status: value.type,
                etat: etat1,
                etat_conversion:etat2,
                cancelled: value.cancelled,
                client: client_str,
                fournisseur: value.fournisseur!=null ? value.fournisseur.name : '',
                superieur: (value.divers_infos!=null && value.divers_infos.superieur_infos!=null && value.divers_infos.superieur_infos.length>maxCarac) ? <span>{value.divers_infos.superieur_infos.replace( /(<([^>]+)>)/ig, '').substring(0,maxCarac)}<span className='lien-to' onClick={()=>setTextModal(value.divers_infos.superieur_infos.replace( /(<([^>]+)>)/ig, ''))}>...</span></span> : (value.divers_infos!=null && value.divers_infos.superieur_infos!=null) ?value.divers_infos.superieur_infos.replace( /(<([^>]+)>)/ig, '') : '', 

                inferieur: (value.divers_infos!=null && value.divers_infos.inferieur_infos!=null && value.divers_infos.inferieur_infos.length>maxCarac) ? <span>{value.divers_infos.inferieur_infos.replace( /(<([^>]+)>)/ig, '').substring(0,maxCarac)}<span className='lien-to' onClick={()=>setTextModal(value.divers_infos.inferieur_infos.replace( /(<([^>]+)>)/ig, ''))}>...</span></span> : (value.divers_infos!=null && value.divers_infos.inferieur_infos!=null) ? value.divers_infos.inferieur_infos.replace( /(<([^>]+)>)/ig, '') : '', 
                amount: <FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={value.ttc} />,
                id: value.id,
                finalise:finalise,
                refacturation: ((tos)?t('fromTo'):(pos)?t('fromPo'):(refacturation)?refacturation_text:''),
                action: 
                    <span className="d-flex justify-content-between">
                        <ProfilActionButton path={'/invoice/details/'+value.id} />
                    </span>,
                index: ind + 1,
            }
            dataTable.push(obj)
        }
    })

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    let columns = [
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "type",
            text: t('document'),
            editable:false,
            sort:false,
            formatter: documentFormatter(t),
        },
        {
            dataField: "bar",
            text: t('referencePo'),
            editable:false,
            sort:false,
        },
        {
            dataField: "createdAt",
            text: t('createdAt'),
            editable:false,
            sort:false,
        },
        {
            dataField: "etat",
            text: t('etat1'),
            editable:false,
            sort:false,
            style: cellStyleEtat(t),
        },
        {
            dataField: "etat_conversion",
            text: t('etat2'),
            editable:false,
            sort:false,
            style: cellStyleEtatConversion(t),
        },
        {
            dataField: "client",
            text: t('customer'),
            editable:false,
            sort:false,
        },
        {
            dataField: "fournisseur",
            text: t('administrationFournisseurForm'),
            editable:false,
            sort:false,
        },
        {
            dataField: "amount",
            text: t('amountTtc'),
            editable:false,
            sort:false,
        },
        {
            dataField: "superieur",
            text: t('topText'),
            editable:false,
            sort:false,
        },
        {
            dataField: "inferieur",
            text: t('bottomText'),
            editable:false,
            sort:false,
        },
        {
            dataField: "refacturation",
            text: t('refacturation'),
            editable:false,
            sort:false,
        },
    ];

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.dossier_facture_table_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.dossier_facture_table_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage('dossier_facture_table_reorganize',arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: dataTable.length,
    };

    const handleFilter = (e) => {
        setFilter(e.target.value)
    }

    return (
        <div>
            <Modal show={textModal} onHide={() => setTextModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {textModal}
                    </div>
                </Modal.Body>
            </Modal>
            <Modal size="xl" show={showModalDocument} onHide={()=>setShowModalDocument(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('documentSaved')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(showModalDocument=='saved') ?
                        <Suspense fallback={<Loading></Loading>}>
                            <ModalSavedFacture 
                                // company={company}
                                folderParam={'/'+props.folderDetail.id}
                            />
                        </Suspense>
                    :
                        false
                    }
                </Modal.Body>
            </Modal>
            {columnOrganize.length!=0 &&
                <small>
                    <ToolkitProvider
                        keyField="index"
                        data={dataTable}
                        columns={columnOrganize}
                        search
                    >
                    {(propst) => (
                        <>
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <ColumDataTableReorganize 
                                        columnOrganize={columnOrganize}
                                        setColumnOrganize={setColumnOrganize}
                                        setCookie={setLocalStorage}
                                        cookieName='dossier_facture_table_reorganize'
                                        showColumnOrganize={showColumnOrganize}
                                        setShowColumnOrganize={setShowColumnOrganize}
                                        btnSwitch={false}//pour affiche ou non le btn swith
                                        initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                    />&nbsp;&nbsp;&nbsp;
                                    {/* <BtnShowDocSaved 
                                        btnStyle="btn btn-sm btn-info"
                                        setShowModalDocument={setShowModalDocument}
                                    />&nbsp; */}
                                    {/* {(props.from && props.from=='modal') ?
                                        false
                                    :
                                        <>
                                            <BtnConvertDocPurchaseOrderB2b 
                                                btnStyle="btn btn-sm btn-primary"
                                                dossierId={props.folderDetail.id}
                                                setReload={props.setReload}
                                            />&nbsp;
                                            <BtnConvertDocDeliveryNoteB2b 
                                                btnStyle="btn btn-sm btn-primary"
                                                dossierId={props.folderDetail.id}
                                                setReload={props.setReload}
                                            />
                                        </>
                                    } */}
                                    <BtnConvertDocPurchaseOrderB2b 
                                        btnStyle="btn btn-sm btn-primary"
                                        dossierId={props.folderDetail.id}
                                        setReload={props.setReload}
                                    />&nbsp;
                                    <BtnConvertDocDeliveryNoteB2b 
                                        btnStyle="btn btn-sm btn-primary"
                                        dossierId={props.folderDetail.id}
                                        setReload={props.setReload}
                                    />
                                </div>
                                <div className="col-4">
                                    <select className="form-control" value={filter} onChange={(e) => handleFilter(e)}>
                                        <option value="all">-- Select --</option>
                                        <option value="creditNote">{t('creditNote')}</option>
                                        <option value="purchaseOrderB2b">{t('purchaseOrderB2b')}</option>
                                        <option value="deliveryNote">{t('deliveryNote')}</option>
                                        <option value="returnNote">{t('returnNote')}</option>
                                        <option value="quotation">{t('quotation')}</option>
                                        <option value="billing">{t('billing')}</option>
                                        <option value="billingBuy">{t('billingBuy')}</option>
                                        <option value="billingDeposit">{t('billingDeposit')}</option>
                                    </select>
                                </div>
                                <div className="d-flex justify-content-end align-items-center">
                                    <span className="mb-2 me-1">{t('tableSearch')}:</span>
                                    <SearchBar {...propst.searchProps} className="mb-2" />
                                </div>
                            </div>
                            <div className="position-relative">
                                <CustomDataTable 
                                    propst={propst}
                                    paginationOptions={paginationOptions}
                                    columns={columns}
                                    defaultSortDirection="asc"
                                    rowStyle={rowStyle(t)}
                                />
                            </div>
                        </>
                    )}
                    </ToolkitProvider>
                </small>
            }
        </div>
    )
};

export default DossierListDocumentTable;